import LitigationBulletin from './[slug]';

export async function getStaticProps() {
  return {
    props: {
      statecode: 0,
    },
  };
}
export default LitigationBulletin;
